export default "/_next/static/assets/hou-phone-mask_b2db2ad61bb8dedae0e3bd418d922836.png";